export const apiConstants = {
  url: "/api/typecategory"
};
